<template>
  <div style="display: flex" class="container">
    <!-- <img src="../assets/images/bottom.png" class="container"> -->
    <div class="serve-flex-col section_7 space-y-18">
      <div class="serve-flex-row serve-justify-between serve-items-end group_5">
        <div
          class="serve-flex-row group_6"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 7.5rem;
            height: 1.09rem;
            box-sizing: border-box;
            padding-top: 0.21rem;
          "
        >
          <div
            class="serve-flex-col serve-items-center group_7"
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin-top: -0.19rem;
            "
          >
            <img
              class="serve-self-start image image_5"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16915495871868923364.png"
            />
            <span
              class="font_1 fix text_13"
              style="
                font-size: 0.09rem;
                line-height: 0.12rem;
                margin-top: 0.05rem;
              "
              >长春市吉泰物流有限公司</span
            >
            <span
              class="font_3 fix text_15"
              style="
                font-size: 0.06rem;
                display: flex;
                align-items: center;
                margin-top: 0.05rem;
              "
            >
              <img
                src="https://official-1317286948.cos.ap-beijing.myqcloud.com/police.png"
                alt=""
                style="width: 0.08rem; height: 0.08rem; opacity: 1"
              />
              <span style="line-height: 0.08rem">
                <a
                  target="_blank"
                  href="https://www.beian.gov.cn/"
                >
                  吉公网安备 22011202000072号
                </a>
              </span>
            </span>
            <span
              class="font_3 fix text_18"
              style="
                font-size: 0.06rem;
                line-height: 0.08rem;
                margin-top: 0.02rem;
              "
            >
              <a
                target="_blank"
                href="https://beian.miit.gov.cn/"
                >吉ICP备2023002322号-2</a
              >
            </span>
            <span
              class="font_3 fix text_17"
              style="
                font-size: 0.06rem;
                line-height: 0.08rem;
                margin-top: 0.01rem;
              "
              >@长春市易航网络科技有限公司 版权所有</span
            >
          </div>
          <div
            style="
              width: 0.001rem;
              height: 0.48rem;
              margin: 0 0.45rem;
              background: #fff;
            "
          ></div>
          <div
            class="serve-flex-row group_8 space-x-34"
            style="display: flex; align-items: center"
          >
            <img
              style="width: 0.41rem; height: 0.41rem; margin-right: 0.13rem"
              class="image_6"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16915495871866509625.png"
            />
            <div
              class="serve-flex-col serve-items-center space-y-28"
              style="
                display: flex;
                align-items: flex-start;
                flex-direction: column;
                justify-content: flex-start;
              "
            >
              <span
                class="font_3 text_14"
                style="
                  font-size: 0.06rem;
                  letter-spacing: 0.065rem;
                  line-height: 0.13rem;
                "
                >全国客服热线：</span
              >
              <span
                class="text_16"
                style="
                  font-size: 0.12rem;
                  letter-spacing: 0.002rem;
                  line-height: 0.13rem;
                  margin-top: 0.06rem;
                  margin-bottom: 0.05rem;
                "
                >400-9999-170</span
              >
              <span
                class="font_6 text_19"
                style="font-size: 0.06rem; line-height: 0.13rem"
                >扫码关注吉泰物流官方公众号</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script> 

<style scoped>
/************************************************************
** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
** 否则页面将无法正常显示                                  **
************************************************************/

.container {
  height: 1.09rem;
  width: 7.5rem;
  margin-bottom: 0;
  padding-bottom: 0;
  font-size: 0.1rem;
  background: #000;
  color: #fff;
  overflow: hidden;
}

html {
  font-size: 256px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.image_5 {
  width: 0.23rem;
  height: 0.14rem;
  /* margin-top: 0.21rem; */
  /* margin-left: 2.49rem; */
}

a {
  text-decoration: none; /* 去除默认的下划线 */
  color: inherit; /* 去除默认的颜色和点击后变化的颜色 */
}
</style>



// WEBPACK FOOTER //
// src/views/bottom.vue